<template>
  <div class="card-info">
    <div class="header-card">
      <!-- <h1 class="general-title">Location</h1> -->
      <font-awesome-icon
        class="icon-title general-title"
        icon="times"
        @click="close"
      />
    </div>
    <div class="body-card">
      <div class="text-section-info">
        <h1 class="general-title">Project / Well Coordinates</h1>
      </div>
      <table>
        <tr class="tr-row">
          <td class="general-title">Latitude</td>
          <td class="text">-38.045047</td>
          <td class="general-title">Longitude</td>
          <td class="text">-67.613233</td>
        </tr>
        <br />
      </table>
      <div id="map">
        <button class="FullScreen" @click="dialog = true">
          <font-awesome-icon icon="expand" />
        </button>
      </div>
      <v-progress-circular
        v-if="loading"
        style="width: 100%; text-align: center"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <FullMapVue
          :lng="lng"
          :lat="lat"
          :zoom="zoom"
          v-on:callback="CloseModalFull()"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import FullMapVue from "./FullMap.vue";
export default {
  props: {
    lng: {
      type: Number,
      required: true,
      default: -74.5,
    },
    lat: {
      type: Number,
      required: true,
      default: 40,
    },
    zoom: {
      type: Number,
      required: true,
      default: 9,
    },
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  components: {
    FullMapVue,
  },
  data: () => ({
    loading: true,
    dialog: false,
  }),
  watch: {
    loading(val) {
      if (!val) {
        this.render();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close", "Location");
    },
    render() {
      var satellite = L.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
          {
            id: "mapbox/satellite-v9",
            tileSize: 512,
            zoomOffset: -1,
            attribution:
              'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            accessToken:
              "pk.eyJ1IjoiZXN0ZWJhbmpzIiwiYSI6ImNrZWhjNWF0eDE1Yncyc3BxcG45MmJpc2QifQ.0qKtoStiG_6OtK9XyqDllQ",
          }
        ),
        streets = L.tileLayer(
          "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
          {
            id: "mapbox/streets-v11",
            tileSize: 512,
            zoomOffset: -1,
            attribution:
              'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            accessToken:
              "pk.eyJ1IjoiZXN0ZWJhbmpzIiwiYSI6ImNrZWhjNWF0eDE1Yncyc3BxcG45MmJpc2QifQ.0qKtoStiG_6OtK9XyqDllQ",
          }
        );

      L.GridLayer.DebugCoords = L.GridLayer.extend({
        createTile: function (coords) {
          var tile = document.createElement("div");
          tile.innerHTML = [coords.x, coords.y, coords.z].join(", ");
          tile.style.outline = "1px solid red";
          return tile;
        },
      });

      L.gridLayer.debugCoords = function (opts) {
        return new L.GridLayer.DebugCoords(opts);
      };

      // mymap.addLayer(L.gridLayer.debugCoords());
      var grid = L.gridLayer.debugCoords();

      var mymap = L.map("map", {
        center: [this.lat, this.lng],
        zoom: this.zoom,
        layers: [satellite, grid],
      });

      var baseMaps = {
        Satellite: satellite,
        Streets: streets,
      };

      var overlayMaps = {
        Grid: grid,
      };

      L.control.layers(baseMaps, overlayMaps).addTo(mymap);

      var greenIcon = L.icon({
        iconUrl: require("../../assets/iconoMapa.png"),
        // shadowUrl: "leaf-shadow.png",

        iconSize: [60, 60], // size of the icon
        // shadowSize: [50, 64], // size of the shadow
        iconAnchor: [30, 58], // point of the icon which will correspond to marker's location
        // shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
      });

      L.marker([this.lat, this.lng], { icon: greenIcon }).addTo(mymap);
    },
    CloseModalFull() {
      this.dialog = false;
    },
  },

  mounted() {
    setTimeout(() => (this.loading = false), 100);
  },
};
</script>

<style>
.text-section-info {
  margin-bottom: 5px;
}
.text-section-info h1 {
  font-size: 1.5rem;
}
.text-section-info p {
  margin: 0;
}
#map {
  width: 100%;
  height: 60vh;
  position: relative;
  z-index: 1;
}
#map .FullScreen {
  font-size: 20px;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 80px;
  left: 12px;
  z-index: 800;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.leaflet-touch .leaflet-bar a {
  color: black;
}
#map canvas {
  width: 100% !important;
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
  .tr-row {
    display: flex;
    flex-direction: column;
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .tr-row {
    display: flex;
    flex-direction: column;
  }
}
</style>